module.exports = __webpack_public_path__ + "static/media/gl.7cfd85a7.webp";